export default __webpack_public_path__ + "static/O0280-a7da5573f4be3da20d5148536d38457f.png";